import { Alert, Col, Collapse, Container, Form, Row } from "react-bootstrap";
import styles from "./SearchContainer.module.css"
import DefaultButton from "../../../../../../components/buttons/default-button/DefaultButton"
import { JSX, useEffect, useState } from "react";
import PlusButton from "../../../../../../components/buttons/plus-button/PlusButton";
import FilterButton from "../../../../../../components/buttons/filter-button/FilterButton";
import { UserSearchParams } from "../Users";
import { SetURLSearchParams } from "react-router-dom";
import { useSetSearchUrlParams } from "../../../../../../hooks/usePagination";

interface SearchContainerProps {
    plusButtonOnClick: () => void;
    searchParameters: UserSearchParams
    setSearchParams: SetURLSearchParams
    pagination: JSX.Element
}

const INT32_MAX = 2147483647

export default function SearchContainer(props: SearchContainerProps) {
    const { plusButtonOnClick, searchParameters, setSearchParams, pagination } = props
    const [ showSearchContainer, setShowSearchContainer ] = useState(false)
    const setSearchUrlParams = useSetSearchUrlParams(setSearchParams)
    const [id, setId] = useState(searchParameters.id)
    const [username, setUsername] = useState(searchParameters.username ?? '')
    const [enabled, setEnabled] = useState(searchParameters.enabled)
    const [showAlert, setShowAlert] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        setId(searchParameters.id)
        setUsername(searchParameters.username ?? '')
        setEnabled(searchParameters.enabled)
    }, [searchParameters])

    return(
        <Container className={styles.searchContainer}>
            <Row className="g-0 position-relative">
                <Col className="col-4 d-flex align-items-center">
                    <div className="me-3">
                        <PlusButton onClick={ e => {
                            e.preventDefault()

                            plusButtonOnClick()
                        }} />
                    </div>

                    <div>
                        <FilterButton title="Szűrő" onClick={() => setShowSearchContainer(prev => !prev)} isOpen={showSearchContainer} />
                    </div>
                </Col>

                <div className="col-8 d-flex relative align-items-center flex-row-reverse">
                   { pagination }
                </div>
            </Row>

            <Collapse in={ showSearchContainer }>
                <div>
                    <Row className={styles.inputFieldsContainer}>
                        <Row className="g-0">
                            <Col className={`d-flex justify-content-center gap-4 align-items-center`}>
                                <div>
                                    <label className={styles.label} htmlFor="id">ID</label>
                                    <input
                                        type="number"
                                        id='id'
                                        placeholder='ID'
                                        value={ id ?? '' }
                                        min={1}
                                        max={INT32_MAX - 1}
                                        className={`${styles.searchInput} ${styles.numberInput}`}
                                        onChange={e => {
                                            const value = e.target.value

                                            if (value === '') {
                                                setId(null)
                                                setErrorMessage('')
                                                setShowAlert(false)
                                                searchParameters.id = null
                                                return
                                            }
                                            
                                            const id = parseInt(value)

                                            if(isNaN(id) || (id > 0 && id < INT32_MAX)) {
                                                setId(id)
                                                setErrorMessage('')
                                                setShowAlert(false)
                                                searchParameters.id = id
                                            }
                                            else {
                                                setErrorMessage('Érvénytelen ID')
                                                setShowAlert(true)
                                                setId(null)
                                                searchParameters.id = null
                                            }
                                        }}
                                    />
                                </div>

                                <div>
                                    <label className={styles.label} htmlFor="username">Felhasználónév</label>
                                    <input
                                        type="text"
                                        id='username'
                                        placeholder='Felhasználónév'
                                        value={ username }
                                        className={styles.searchInput}
                                        onChange={e => {
                                            const username = e.target.value
                                            setUsername(username)

                                            if(username.length === 0) {
                                                searchParameters.username = null
                                                return
                                            }

                                            searchParameters.username = username
                                        }}
                                    />
                                </div>
                                
                                <div>
                                    <label className={styles.label} htmlFor="enabled">Aktív?</label>
                                    <Form.Select 
                                        id="enabled"
                                        value={
                                            enabled === null
                                            ? ''
                                            : enabled === true
                                                ? 'yes'
                                                : 'no'
                                        }
                                        onChange={(e) => {
                                            let value: boolean | null

                                            if (e.target.value === '') {
                                                value = null
                                            } else {
                                                value = e.target.value === 'yes'
                                            }

                                            setEnabled(value)
                                            searchParameters.enabled = value
                                        }}
                                        className={styles.searchInput}
                                    >
                                        <option value=''>Minden</option>
                                        <option value='yes'>Igen</option>
                                        <option value='no'>Nem</option>
                                    </Form.Select>
                                </div>
                            </Col>
                        </Row>

                        <Row className="g-0 pt-2">
                            <Col className={`d-flex pt-5 justify-content-center align-items-end position-relative`}>
                                <Alert
                                    show={ showAlert }
                                    variant='danger'
                                    dismissible={ false }
                                    className={ styles.alert }
                                >
                                    <span dangerouslySetInnerHTML={{__html: errorMessage }}></span>
                                </Alert>

                                <DefaultButton title="Keresés" onClick={e => {
                                    e.preventDefault()
                                    
                                    setSearchUrlParams(searchParameters)
                                }} />
                            </Col>
                        </Row>
                    </Row>
                </div>
            </Collapse>
        </Container>
    )
}